import type { SalonThemeConfig } from './salonsApi';


interface SalonThemeTargetsRequest {
  salonId: number;
  language?: string;
}

interface SalonThemeApplyRequest {
  salonId: number;
  theme: SalonThemeConfig;
  salonIds: number[];
}

export const buildSalonThemeTargetsRequest = ({
  salonId,
  language,
}: SalonThemeTargetsRequest) => ({
  url: `/api/salons/${salonId}/theme/targets/`,
  params: language ? { language } : undefined,
});

export const buildSalonThemeApplyRequest = ({
  salonId,
  theme,
  salonIds,
}: SalonThemeApplyRequest) => ({
  url: `/api/salons/${salonId}/theme/apply/`,
  method: 'POST',
  body: {
    theme,
    salon_ids: [...salonIds].sort((left, right) => left - right),
  },
});
